import React from 'react'

const TextErrorMessage = ({ message, children }) => (
  <>
    {message && <p className="text-red-500">{message}</p>}
    {children}
  </>
)

export default TextErrorMessage
